import React from "react";
import { Image } from "react-native";

interface Props { size?: number }

export default function GalleryIcon({ size = 24 }: Props) {
  return <Image source={require("../../assets/icons/gallery.png")} style={{ width: size, height: size }} resizeMode="contain" />;
}
